import { useRef, useState, useEffect } from "react";
import FadeInUp from "../../../components/FadeInUp";
import useIsMobile from "../../../hook/useIsMobile"
import { useInView } from "framer-motion";

export default function CoreProblemStatement() {

    const containerRef = useRef(null);
    const isMobile = useIsMobile();

    const PersonIcon = ({ fill }) => {
        return (
        <svg xmlns="http://www.w3.org/2000/svg" width={isMobile ? 24 : 42} height={isMobile ? 65 : 111} viewBox="0 0 42 111" fill="none">
            <path d="M26.2452 25.7719C33.0931 22.8732 36.2852 14.9942 33.3748 8.1736C30.4644 1.35305 22.5537 -1.82622 15.7058 1.07252C8.85781 3.97126 5.66577 11.8503 8.57615 18.6709C11.4865 25.4914 19.3972 28.6707 26.2452 25.7719Z" fill={fill}/>
            <path d="M42 62.6317C42 66.5535 39.4943 69.9999 35.7955 71.3071L33.8864 71.9013L31.8579 106.603C31.7386 109.099 29.7103 111 27.2045 111H14.7955C12.2897 111 10.2613 109.099 10.1421 106.603L8.11356 71.9013L6.20449 71.3071C2.50565 69.9999 0 66.5535 0 62.6317L0.119287 38.0316C0.119287 34.5853 2.38637 31.7331 5.72719 30.9012L9.77353 29.931C11.3659 29.5492 12.9979 29.3563 14.6358 29.3563H27.3642C29.0021 29.3563 30.6341 29.5492 32.2265 29.931L36.2728 30.9012C39.4943 31.7331 41.8807 34.7041 41.8807 38.0316L42 62.6317Z" fill={fill}/>
        </svg>
        )
    }

    const HalfPersonIcon = () => {
        return (
        <svg width={isMobile ? 24 : 42} height={isMobile ? 65 : 111} viewBox="0 0 42 111" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M26.2452 25.7719C33.0931 22.8732 36.2852 14.9942 33.3748 8.1736C30.4644 1.35305 22.5537 -1.82622 15.7058 1.07252C8.8578 3.97126 5.66577 11.8503 8.57615 18.6709C11.4865 25.4914 19.3972 28.6707 26.2452 25.7719Z" fill="#E0E0E0"/>
            <path d="M42 62.6317C42 66.5535 39.4943 69.9999 35.7955 71.3071L33.8864 71.9013L31.8579 106.603C31.7386 109.099 29.7103 111 27.2045 111H14.7955C12.2897 111 10.2613 109.099 10.1421 106.603L8.11356 71.9013L6.20449 71.3071C2.50565 69.9999 0 66.5535 0 62.6317L0.119287 38.0316C0.119287 34.5853 2.38637 31.7331 5.72719 30.9012L9.77353 29.931C11.3659 29.5492 12.9979 29.3563 14.6358 29.3563H27.3642C29.0021 29.3563 30.6341 29.5492 32.2265 29.931L36.2728 30.9012C39.4943 31.7331 41.8807 34.7041 41.8807 38.0316L42 62.6317Z" fill="#E0E0E0"/>
            <mask id="mask0_51399_168" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="42" height="111">
            <path d="M26.2452 25.7719C33.0931 22.8732 36.2852 14.9942 33.3748 8.1736C30.4644 1.35305 22.5537 -1.82622 15.7058 1.07252C8.8578 3.97126 5.66577 11.8503 8.57615 18.6709C11.4865 25.4914 19.3972 28.6707 26.2452 25.7719Z" fill="#E0E0E0"/>
            <path d="M42 62.6317C42 66.5535 39.4943 69.9999 35.7955 71.3071L33.8864 71.9013L31.8579 106.603C31.7386 109.099 29.7103 111 27.2045 111H14.7955C12.2897 111 10.2613 109.099 10.1421 106.603L8.11356 71.9013L6.20449 71.3071C2.50565 69.9999 0 66.5535 0 62.6317L0.119287 38.0316C0.119287 34.5853 2.38637 31.7331 5.72719 30.9012L9.77353 29.931C11.3659 29.5492 12.9979 29.3563 14.6358 29.3563H27.3642C29.0021 29.3563 30.6341 29.5492 32.2265 29.931L36.2728 30.9012C39.4943 31.7331 41.8807 34.7041 41.8807 38.0316L42 62.6317Z" fill="#E0E0E0"/>
            </mask>
            <g mask="url(#mask0_51399_168)">
            < rect width="21" height="111" fill="#FF692E"/>
            </g>
        </svg>
        )
    }

    const CircleProcessBar = ({ value, text }) => {
        const [percent, setPercent] = useState(0);
        const isInView = useInView(containerRef, { once: true, });

        useEffect(() => {
            if (isInView) {
                setPercent(value); // 원이 그려지는 값
            }
        }, [isInView]);
    
        return (
            <div className='relative '>
                <svg className='-rotate-90 mx-auto' width={300} height={300} viewBox="0 0 300 300">
                    <circle
                        className='fill-none stroke-primary-100'
                        cx="150" cy="150" r="140"
                        strokeWidth="14"
                    />
                    <circle
                        className='fill-none stroke-primary-400 transition-all ease-in-out duration-500'
                        cx="150" cy="150" r="140"
                        strokeWidth="14"
                        strokeLinecap="round"
                        strokeDasharray={(2 * Math.PI * 140) + 'px'}
                        strokeDashoffset={((1 - percent / 100) * (2 * Math.PI * 140)) + 'px'}
                    />
                </svg>

                <div className='absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 text-center'>
                    <div className='text-display2 lg:text-display1 font-medium'>
                    {value}%
                    </div>

                    <div className='text-body1 lg:text-heading1 text-label-200 '>
                    {text}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <section ref={containerRef} className='w-full min-h-screen bg-[#FAFAFA]'>
            <div className="flex flex-col items-center py-[140px] bg-[#FAFAFA]">
                <h2 className="font-bold text-title2 lg:text-display2 text-center text-label-400">
                    전동차 사고 위험,<br/>
                    왜 <span className="text-primary-400">링콜</span>이 필요한가요?
                </h2>

                <FadeInUp>
                    <div 
                        className={`text-[#E43746] text-center font-extrabold bg-[#000] 
                        ${isMobile ? 'mt-[31px] w-full py-[20px] text-title1' : 'mt-[88px] px-[65px] py-[16px] text-display1 '}`}
                        style={{ clipPath: !isMobile && 'polygon(2% 0%, 100% 0%, 98% 100%, 0% 100%)' }}
                    >
                        전동차 이용자 4명 중 3명<br/>
                        "교통사고가 날 뻔한 경험이 있다"
                    </div>

                    <div className='wrapper flex flex-wrap justify-center gap-[24px] lg:gap-[36px] mt-[100px]'>
                        <PersonIcon fill='#FF692E'/>
                        <PersonIcon fill='#FF692E'/>
                        <PersonIcon fill='#FF692E'/>
                        <PersonIcon fill='#FF692E'/>
                        <PersonIcon fill='#FF692E'/>
                        <PersonIcon fill='#FF692E'/>

                        
                        <PersonIcon fill='#E0E0E0'/>
                        <PersonIcon fill='#E0E0E0'/>
                    </div>
                </FadeInUp>

                <div className='wrapper mt-[120px] flex flex-col lg:justify-center lg:flex-row gap-[85px]'>
                    <CircleProcessBar value={69.2} text='한 달에 한 번 이상'/>
                    <CircleProcessBar value={10.2} text='매주'/>
                </div>
                
                <FadeInUp delay={0.3}>
                    <div className=' mt-[72px] text-center font-medium text-heading3 lg:text-title2 text-label-300s'>
                        69.2%는 한 달에 한 번 이상, 10.2%는 매주<br/>
                        사고 위험에 노출되고 있습니다.
                    </div>
                </FadeInUp>

                <div className='mt-[40px] text-label-100 text-body1 font-normal'>
                    *도로교통공단 보도자료, 2023년
                </div>
            </div>
        </section>
    )
}